import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import React from "react";
import { useTrainDetail } from "./useTrainDetail";
import { trainSections } from "./trainSections";
import { getTrainFieldMetaData } from "shared/utils/fieldsHelper/trainFields";
import { LinkedShowSimplePanel } from "document/linkshow/LinkedShowSimplePanel";
import { type LinkShowToTravelConfig } from "components/LinkShowToTravelButton";

interface Props {
  train: server.dto.Train
  linkedShows: server.dto.LinkedShow[]
  linkShowToTravel: LinkShowToTravelConfig
  travellers: server.dto.ContactSmallV2[]
  files: server.dto.File[]
  onArtistChanged: (newArtist: server.dto.ArtistSmall) => void
  onDateChanged: (newDate: server.dto.AppointmentDateTime) => void
  onStatusChanged: () => void
}

export const TrainDetailSection = (props: Props) => {
  const {
    state,
    onValueChanged,
    onSuccessfulUpdate,
    refetchFiles,
    getUpdateTrainDetails,
  } = useTrainDetail(
    props.train,
    props.travellers,
    props.files,
    props.onArtistChanged,
    props.onDateChanged,
    props.onStatusChanged,
  );

  const fieldMetaData = getTrainFieldMetaData(site.currentEnvironment, state, props.train.permissions);

  return <DetailSectionTemplate
    isInPageEditable={props.train.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdate}
    sections={[
      ...trainSections(state, fieldMetaData, refetchFiles, getUpdateTrainDetails),
      {
        key: "linkedShows",
        type: "custom",
        render: () => <LinkedShowSimplePanel
          key="linkedShows"
          linkedShows={props.linkedShows}
          linkShowToTravel={props.linkShowToTravel}
        />
      }
    ]}
  />
}
